import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import Tippy from '@tippyjs/react';
// import 'tippy.js/dist/tippy.css';
// import 'tippy.js/animations/scale.css';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  HStack,
  Button,
  VStack,
  Text,
} from '@chakra-ui/react';

import { useMutation } from '@apollo/client';

// import styled from '../../../../../consts/styled';
import { State } from '../hooks/useGetUnitDataGql';
import ChakraReactSelect, { OptionType } from './ChakraReactSelect';

import {
  Mutation,
  StudyGroup,
  Track,
} from '../../../../../generated/graphqlModels';

import { CHOOSE_TRACK } from '../queries';
import { trackAction } from '../../../../../helpers/trackAction';

interface SelectTrackAndStudyGroupModalProps {
  trackId?: string;
  studyGroupId?: string;
  tracks?: Track[];
  studyGroups?: StudyGroup[];
  updateParentState: (_: Partial<State>) => void;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SelectTrackAndStudyGroupModal: React.FC<
  SelectTrackAndStudyGroupModalProps
> = (props) => {
  const {
    trackId,
    studyGroupId,
    tracks,
    studyGroups,
    updateParentState,
    isOpen,
    setIsOpen,
  } = props;

  const { t } = useTranslation();

  const onClose = () => setIsOpen(false);

  const [chooseTrack] = useMutation<Mutation>(CHOOSE_TRACK);

  const trackOptions = useMemo(() => {
    const opts: OptionType[] = [];
    tracks?.forEach((t) => {
      opts.push({ id: t.id, label: t.name });
    });
    return opts;
  }, [tracks]);

  const studyGroupOptions = useMemo(() => {
    const opts: OptionType[] = [];
    studyGroups?.forEach((t) => {
      opts.push({ id: t.id, label: t.name, secondaryLabel: t.schoolName });
    });
    return opts;
  }, [studyGroups]);
  // @ts-expect-error
  const modalTitle = `${t('selectTrackAndStudyGroupModal.select')} ${tracks?.length > 1 ? t('selectTrackAndStudyGroupModal.track') : ''}${
    // @ts-expect-error
    tracks?.length > 1 && studyGroups?.length > 1 ? ' and ' : ''
    // @ts-expect-error
  }${studyGroups?.length > 1 ? 'class' : ''}`;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <HStack justifyContent="center" spacing={8}>
            {tracks && tracks.length > 1 && (
              <VStack>
                <Text>{t('selectTrackAndStudyGroupModal.pleaseSelectLearningPath')} </Text>
                <ChakraReactSelect
                  selectedId={trackId}
                  options={trackOptions}
                  onSelect={(trackId) => {
                    if (studyGroupId) {
                      chooseTrack({ variables: { trackId, studyGroupId } });
                      trackAction({
                        action_type: 'choose_track',
                        study_group: { pk: studyGroupId },
                        data: { trackId, studyGroupId },
                      });
                    }
                    updateParentState({ trackId });
                  }}
                />
              </VStack>
            )}
            {studyGroups && studyGroups.length > 1 && (
              <VStack>
                <Text>{t('selectTrackAndStudyGroupModal.selectClass')} </Text>
                <ChakraReactSelect
                  selectedId={studyGroupId}
                  options={studyGroupOptions}
                  onSelect={(studyGroupId) => {
                    updateParentState({ studyGroupId });
                  }}
                />
              </VStack>
            )}
          </HStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            {t('general.close')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SelectTrackAndStudyGroupModal;
